import { PDFDocument, rgb, degrees, StandardFonts } from "pdf-lib";
import download from "downloadjs";

import { uploadToS3 } from "./S3UploadHelper";
import { updateDynamoDB } from "./DynamoDBHelper";

import * as pdfjs from 'pdfjs-dist/webpack';
import { jsPDF } from "jspdf";

export async function modifyPdf({
  oen,
  printDate,
  selectedFile,
  fileBinary,
  setStatus,
  canvasRef,
  setError,
}) {

  const uuidValue =  Math.floor(100000 + Math.random() * 900000).toString()

  console.log(selectedFile);

  // const url = 'https://uva-transcripts.s3.amazonaws.com/Ma+Shihan.pdf'
  // const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

  const pdfDoc = await PDFDocument.load(fileBinary);
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();

  for (let x = -10; x < 10; x++) {
    for (let y = -10; y < 10; y++) {
      firstPage.drawText('UVA Future', {
        x: x * 100,
        y: y * 200,
        size: 50,
        font: helveticaFont,
        color: rgb(0.8, 0.8, 0.8),
        rotate: degrees(-45),
        opacity: 0.5,
      })
    }
  }

  const verificationText = "Verify at https://uvaschool.org/validate - Code: " + uuidValue
  firstPage.drawText(verificationText, {
    x: 5,
    y: 4,
    size: 10,
    font: helveticaFont,
    color: rgb(0.95, 0.1, 0.1),
  });

  const pdfBytes = await pdfDoc.save();


  const loadingTask = pdfjs.getDocument({ data: pdfBytes });
  loadingTask.promise
    .then(function (pdfDocument) {
      // Request a first page
      console.log("here")
      return pdfDocument.getPage(1).then(function (pdfPage) {
        // Display page on the existing canvas with 100% scale.
        const canvas = canvasRef.current

        const viewport = pdfPage.getViewport({ scale: 1.0 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext("2d");
        ctx.filter = 'grayscale(1)';

        const renderTask = pdfPage.render({
          canvasContext: ctx,
          viewport,
        });
        return renderTask.promise;
      });
    }).then(async function () {

      const canvas = canvasRef.current

      var imgData = canvas.toDataURL("image/png", 1);
      var pdf = new jsPDF("l", "px", [width,height]);
      let new_width = pdf.internal.pageSize.getWidth();
      let new_height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 0, 0, new_width, new_height);
      const finalBytes = pdf.output('arraybuffer');

      try {
        await uploadToS3(finalBytes, uuidValue);
      } catch (e) {
        setError(e.message);
      }
    }).catch(function (reason) {
      console.error("Error: " + reason);
    });
   
    try {
      await updateDynamoDB({ uuidValue, oen, printDate });
      setStatus(true);

    } catch (e) {
      setError(e.message);
    }
    return uuidValue;
}


export async function downloadPdf({ uuidValue, setError }) {
  const url = `https://uva-transcripts.s3.amazonaws.com/${uuidValue}.pdf`;
  try {
    const existingPdfBytes = await fetch(url).then((res) => {
      if (res.status === 200) {
        return res.arrayBuffer();
      } else {
        console.log("ERROR");
        throw new Error(`Invalid UUID. If you just uploaded a file, please wait 30 seconds and retry.`);
      }
    });

    const pdfDoc = await PDFDocument.load(existingPdfBytes)
    const pdfBytes = await pdfDoc.save()


    download(pdfBytes, `${uuidValue}.pdf`, "application/pdf");
  } catch (e) {
    console.log(e);
    setError(e.message);
  }
}
